import React from 'react';
import PropTypes from 'prop-types';

import PatternLibModalComponent from '../../common/modals/PatternLibModalComponent';
import ActiveStandingOrderRepeatingFields from './ActiveStandingOrderRepeatingFields';
import ActiveStandingOrderSingleFields from './ActiveStandingOrderSingleFields';
import { CalloutComponent } from '../../common/CalloutComponent';
import StringConstant from '../../../constants/StringConstants';
import ManagePaymentActionCreator from '../../../actions/ManagePaymentActionCreator';
import EditPaymentsStore_new from '../../../stores/EditPaymentsStore_new';
import ErrorPopUpComponent from '../../common/ErrorPopUpComponent';
import SvgIcon from '../../common/SvgIcon';
import LoaderComponent from '../../common/LoaderComponent';
import CancelActions from './CancelActions';

class CancelStandingOrderModal extends React.Component {
  constructor(props) {
    super(props);
    this.cancelPayment = this.cancelPayment.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.state = {
      showModal: 'VIEW',
    };
  }
  componentWillMount() {
    EditPaymentsStore_new.addChangeListener(this.onStoreChange);
  }
  onStoreChange() {
    const cancelPaymentResponse =
      EditPaymentsStore_new.getCancelPaymentResponse();
    if (cancelPaymentResponse.code === 201) {
      this.setState({ showModal: 'SUCCESS' });
    } else {
      this.setState({ showModal: 'FAILURE' });
    }
  }
  componentDidMount() {}
  componentWillUnmount() {
    EditPaymentsStore_new.removeChangeListener(this.onStoreChange);
  }
  modalBody() {
    return (
      <div>
        <p>{StringConstant.cancelSOSubHeader} </p>
        <CalloutComponent
          dClass="callout callout__full"
          paraText={this.props.content.after4pmMessage}
        />
        {this.props.cancelPaymentData.soType === 'SINGLE' ? (
          <ActiveStandingOrderSingleFields
            activeData={this.props.cancelPaymentData}
          />
        ) : (
          <ActiveStandingOrderRepeatingFields
            activeData={this.props.cancelPaymentData}
          />
        )}
      </div>
    );
  }
  successBody() {
    return (
      <div>
        <SvgIcon id="icon-success" width="128px" height="128px" />
        <h3>{StringConstant.cancelledSOSuccessHeader}</h3>
        <p className="type--jura">{StringConstant.cancelledDDSOSuccessBody}</p>
      </div>
    );
  }
  cancelPayment() {
    this.setState({ showModal: 'LOADER' });
    ManagePaymentActionCreator.cancelPayment(this.props.cancelPaymentData);
  }
  render() {
    const cancelButtonText =
      this.props.cancelPaymentData.paymentType === StringConstant.SOText
        ? StringConstant.cancelSOButton
        : StringConstant.cancelSinglePayment;
    switch (this.state.showModal) {
      case 'VIEW':
        let modalHeader = this.props.cancelPaymentData.paymentType;
        if (modalHeader === StringConstant.SOText) {
          modalHeader = 'standing order';
        }
        return (
          <PatternLibModalComponent
            customClass={'c-modal review-modal cancelled-standing-order-modal'}
            show
            onHide={this.props.closeModal}
            bsSize={'large'}
            modalHeading={`Cancel ${modalHeader}`}
            modalBody={this.modalBody()}
            modalInContainer={false}
            modalFooter={
              <CancelActions
                closeModal={this.props.closeModal}
                closeText={StringConstant.close}
                cancelPayment={this.cancelPayment}
                cancelButtonText={cancelButtonText}
              />
            }
          />
        );
      case 'LOADER':
        return (
          <PatternLibModalComponent
            customClass={'c-modal review-modal cancelled-standing-order-modal'}
            show
            onHide={this.props.closeModal}
            closeButton={false}
            modalHeading={''}
            bsSize={'large'}
            modalBody={<LoaderComponent type="small" />}
            modalInContainer={false}
          />
        );
      case 'SUCCESS':
        return (
          <PatternLibModalComponent
            customClass={
              'c-modal c-modal--center cancelled-standing-order-modal'
            }
            show
            modalHeading={''}
            modalFooter={''}
            onHide={this.props.closeModal}
            bsSize={'large'}
            modalBody={this.successBody()}
            modalInContainer={false}
            modalFooter={
              <button
                onClick={this.props.closeModal}
                className="c-btn c-btn--default c-modal__button"
              >
                {StringConstant.ok}
              </button>
            }
          />
        );
      case 'FAILURE':
        const response = EditPaymentsStore_new.getCancelPaymentResponse();
        return (
          <ErrorPopUpComponent
            error={response.error}
            closeErrorPopup={this.props.closeModal}
            content={this.props.content}
          />
        );
    }
  }
}
CancelStandingOrderModal.propTypes = {
  content: PropTypes.object,
  closeModal: PropTypes.func,
  cancelPaymentData: PropTypes.shape({
    paymentType: PropTypes.string,
  }),
};

CancelStandingOrderModal.defaultProps = {
  content: {},
};
export default CancelStandingOrderModal;
